import axios, { AxiosInstance } from 'axios';
import AxiosMockAdapter from 'axios-mock-adapter';
import {
  apiUserManagerURL,
  mockAndDevelopment,
  productive,
} from 'src/app.config';

const userClient: AxiosInstance =
  productive() && mockAndDevelopment()
    ? axios.create()
    : axios.create({
        baseURL: apiUserManagerURL(),
        headers: {
          accept: '*/*',
          'content-type': 'application/json',
        },
      });

export const mock =
  process.env.NODE_ENV !== 'production' && mockAndDevelopment()
    ? new AxiosMockAdapter(userClient, { delayResponse: 5 })
    : new AxiosMockAdapter(axios.create());

export default userClient;
